module.exports = __webpack_public_path__ + "img/hourglass-start.30eae2a2.svg";